<template>
    <div>
        <a :href="`${possibleLangPrefix}/begeleiding/${content.slug}`" class="block group">
            <div class="relative">
                <div class="aspect-w-4 aspect-h-5 w-full"></div>
                <div class="absolute w-full h-full top-0 left-0">
                    <picture class="absolute w-full h-full top-0 overflow-hidden left-0" v-if="content.acf.image">
                        <img :data-src="content.acf.image.url" :alt="content.acf.image.title" class="w-full h-full object-cover lazyload group-hover:scale-110 transition-transform duration-300 origin-center" />

                        <div class="text-primary-400 bg-gray-800 px-xs py-[20px] flex items-center justify-center absolute bottom-0 right-0">
                            <div class="absolute -translate-x-full w-auto h-full top-0 left-xxs">
                                <img src="/images/brush_left_default.png" class="w-auto h-full" alt="" />
                            </div>

                            <i class="fa-regular fa-arrow-right group-hover:translate-x-xxs duration-300 transition-transform"></i>
                        </div>
                    </picture>
                </div>
            </div>

            <div class="mt-sm sm:mt-[1.5625rem] group-hover:text-primary-400 transition-colors">
                <div class="flex justify-between">
                    <h3 class="group-hover:text-primary-400 text-h4 sm:text-h3 transition-colors" v-html="content.title.rendered"></h3>
                    <span v-show="distanceObject.distance" class="shrink-0 ml-xs text-primary-400 text-sm pt-xxs"> {{ distanceString }}</span>
                </div>

                <div class="mt-[.5rem] text-gray-500 text-xs">
                    <span v-for="(cat, index) in content.categories_objects" :key="index">
                        <span class="mr-xxs"> {{ cat.name }}, </span>
                    </span>
                    <div v-if="locationString">
                        {{ locationString }}
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'supportdetail',
    props: ['content', 'distanceObject'],

    computed: {
        distanceString() {
            if (this.distanceObject && this.distanceObject.distance) {
                const roundedDistance = Math.round(this.distanceObject.distance / 5) * 5;

                if (roundedDistance < 10) {
                    return '< 10 km';
                }
                if (roundedDistance > 200) {
                    return '> 200 km';
                }
                if (roundedDistance > 150) {
                    return '> 150 km';
                }
                if (roundedDistance > 100) {
                    return '> 100 km';
                }
                if (roundedDistance > 50) {
                    return '> 50 km';
                }
                return `± ${roundedDistance} km`;
            }
            return '';
        },

        locationString() {
            let locationString = '';
            let allAddresses = [this.content.acf.address_google_maps];
            if (this.content.acf.other_addresses) {
                allAddresses = allAddresses.concat(this.content.acf.other_addresses.map((o) => o.address_google_maps));
            }

            if (this.distanceObject && this.distanceObject.location) {
                allAddresses = [...allAddresses.filter((a) => this.distanceObject.location.place_id === a.place_id), ...allAddresses.filter((a) => this.distanceObject.location.place_id !== a.place_id)];
            }

            locationString = allAddresses
                .map((a) => {
                    if (a.country_short === 'BE') {
                        const formattedAddress = a.address.replace(a.street_name, '').replace(a.post_code, '').replace(a.street_number, '').replace(a.country, '');
                        const formattedAddressParts = formattedAddress
                            .split(',')[1]
                            .split(' ')
                            .filter((s) => s !== '');
                        if (formattedAddressParts.length === 1) {
                            return formattedAddressParts[0];
                        }
                        if (formattedAddressParts.length > 1) {
                            return `${formattedAddressParts[0]} (${formattedAddressParts[1]})`;
                        }
                    } else {
                        return `${a.city} (${a.country_short})`;
                    }
                    return a.city;
                })
                .join(' / ');
            return locationString;
        },

        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },
};
</script>
